import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import store from "./store"
import Notifications from "vue-notification";
import VModal from "vue-js-modal";
import nonFictionNavBar from "@c/navbar/";
import hbDropdown from "bp-vuejs-dropdown";
import loader from "@c/loader";
import VueObserveVisibility from "vue-observe-visibility";
import VueLazyload from "vue-lazyload";
import VueMultiselect from "vue-multiselect";
import Cookies from "js-cookie";
import VTooltip from "v-tooltip";
import VueHotkey from "v-hotkey";
import VueGtm from "vue-gtm";
import playerEventsMixinsg from "@/mixins/googleTagManagerMixins.js";
import userTrackingMixin from "@/mixins/userTracking.js";
import VueMobileDetection from "vue-mobile-detection";
import "@/components/global-styles";
import "./config";

// App Components
import navBar from "@c/navbar";
import cardBox from "@c/card-box";
import addCreditcard from "@c/credit-card/card";
import creditcardDetails from "@c/credit-card/details";
import creditcardNetworks from "@c/credit-card/networks-strip";
import passwordInput from "@c/password-input";
import sectionTitle from "@c/section-title";

// Plugins
Vue.use(Notifications);
Vue.use(VueObserveVisibility);
Vue.use(VueLazyload, {
    loading: require("@assets/img/cover-placeholder.jpg"),
    error: require("@assets/img/cover-placeholder.jpg")
});
VTooltip.enabled = window.innerWidth > 991;
Vue.use(VTooltip);
Vue.use(VueHotkey);
Vue.use(VueGtm, {
    id: process.env.VUE_APP_GOOGLE_TAG_MANAGER_ID,
    enabled: true,
    debug: process.env.NODE_ENV === "development",
    vueRouter: router
});
Vue.use(VueMobileDetection);

// Components
Vue.use(VModal, { dynamic: true, injectModalsContainer: true });
Vue.component("non-fiction-nav-bar", nonFictionNavBar);
Vue.component("hb-dropdown", hbDropdown);
Vue.component("loader", loader);
Vue.component("multiselect", VueMultiselect);

Vue.component("navBar", navBar);
Vue.component("cardBox", cardBox);
Vue.component("addCreditcard", addCreditcard);
Vue.component("creditcardDetails", creditcardDetails);
Vue.component("creditcardNetworks", creditcardNetworks);
Vue.component("passwordInput", passwordInput);
Vue.component("section-title", sectionTitle);


// Mixins
Vue.mixin(playerEventsMixinsg);
Vue.mixin(userTrackingMixin);

window.Cookies = Cookies;

Vue.config.productionTip = false
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app")

